import { useUserSettingsGet, useGetInfo } from '@ping/api';
import {
  generateMarketPairsData,
  groupMarkets,
  filterMiaxMarketPairs,
  mergeListedMarketsFromInfo,
} from '@ping/helpers';
import { useIsUserLoggedIn } from '@ping/hooks';
import { marketDataStore } from '@ping/stores/marketData.store';

export const getPairs = () => {
  const isUserLoggedIn = useIsUserLoggedIn();

  const { data: userSetting } = useUserSettingsGet({
    query: {
      enabled: isUserLoggedIn,
      staleTime: Infinity, // will be invalidated when the user selects/deselects a favorite market
    },
  });

  // Get market info with marketType information
  const { data: marketInfo } = useGetInfo({ query: { select: ({ pairs }) => pairs } });

  const market = marketDataStore.getMarketData();
  let marketValues = mergeListedMarketsFromInfo([...market.values()], marketInfo);

  marketValues = marketValues.filter(marketData => filterMiaxMarketPairs(marketData, marketInfo));

  return groupMarkets.byAssetName(generateMarketPairsData(marketValues, userSetting?.data?.favoriteMarkets));
};
